export enum MolarTubeType {
  'SNAPLINK_TUBE' = 'Stock Snaplink Tube',
  'ACCENT_MINI_TUBE' = 'Stock Accent Mini Tube',
}

export enum MolarTubeTypeLocalizationKey {
  'SNAPLINK_TUBE' = 'SNAPLINK_TUBE',
  'ACCENT_MINI_TUBE' = 'ACCENT_MINI_TUBE',
}
